(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.querySelector('[data-section-id="{{ section.id }}"]');
  if (!root) return;

  // --- Native lightbox (no external scripts) ---
  const overlay = document.createElement('div');
  overlay.className = 'vf-overlay';
  overlay.innerHTML = `
    <div class="vf-frame">
      <div class="vf-topbar">
        <div class="vf-title" data-vf-title></div>
        <div class="vf-actions">
          <a target="_blank" rel="noopener" data-vf-product>View Product</a>
          <button type="button" data-vf-contact>Contact us</button>
          <button type="button" data-vf-share>Share</button>
        </div>
      </div>
      <div class="vf-stage">
        <button class="vf-prev" aria-label="Previous">‹</button>
        <div class="vf-media" data-vf-media></div>
        <button class="vf-next" aria-label="Next">›</button>
      </div>
      <button class="vf-close" aria-label="Close">✕</button>
      <div class="vf-strip" data-vf-strip></div>
    </div>`;
  document.body.appendChild(overlay);

  const els = {
    title: overlay.querySelector('[data-vf-title]'),
    product: overlay.querySelector('[data-vf-product]'),
    contact: overlay.querySelector('[data-vf-contact]'),
    share: overlay.querySelector('[data-vf-share]'),
    media: overlay.querySelector('[data-vf-media]'),
    strip: overlay.querySelector('[data-vf-strip]'),
    prev: overlay.querySelector('.vf-prev'),
    next: overlay.querySelector('.vf-next'),
    close: overlay.querySelector('.vf-close')
  };

  let state = { items: [], index: 0, id: '', caption: '', productUrl: '#' };

  function renderSlide() {
    const item = state.items[state.index]; if (!item) return;
    els.media.innerHTML = '';
    if (item.video) {
      const v = document.createElement('video');
      v.src = item.src; v.controls = true; v.preload = 'metadata';
      els.media.appendChild(v);
    } else {
      const img = document.createElement('img');
      img.src = item.src; img.alt = state.caption || '';
      els.media.appendChild(img);
    }
    [...els.strip.children].forEach((t,i)=>t.classList.toggle('is-active', i===state.index));
  }

  function openOverlay(items, startIndex, caption, productUrl, id) {
    state = { items, index: startIndex||0, id, caption: caption||'', productUrl: productUrl||'#' };
    els.title.textContent = caption || '';
    els.product.href = productUrl || '#';
    overlay.classList.add('open');

    els.strip.innerHTML = '';
    items.forEach((it, i)=>{
      const th = document.createElement('button');
      th.type='button'; th.className='vf-thumb'+(i===state.index?' is-active':'');
      const thumbUrl = it.thumb || it.src;
      const img = document.createElement('img'); img.src = thumbUrl; img.alt = '';
      th.appendChild(img);
      th.addEventListener('click', ()=>{ state.index = i; renderSlide(); });
      els.strip.appendChild(th);
    });

    renderSlide();
    try { history.replaceState(null, '', '#item-' + encodeURIComponent(id)); } catch(_){}
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay() {
    overlay.classList.remove('open');
    els.media.innerHTML = ''; els.strip.innerHTML = '';
    document.body.style.overflow = '';
  }

  els.prev.addEventListener('click', ()=>{ state.index = (state.index-1+state.items.length)%state.items.length; renderSlide(); });
  els.next.addEventListener('click', ()=>{ state.index = (state.index+1)%state.items.length; renderSlide(); });
  els.close.addEventListener('click', closeOverlay);
  overlay.addEventListener('click', (e)=>{ if (e.target===overlay) closeOverlay(); });
  document.addEventListener('keydown', (e)=>{ if (!overlay.classList.contains('open')) return;
    if (e.key==='Escape') closeOverlay();
    if (e.key==='ArrowLeft') els.prev.click();
    if (e.key==='ArrowRight') els.next.click();
  });
  els.contact.addEventListener('click', ()=>{
    const modal = document.querySelector('.cg-modal[data-for-section="{{ section.id }}"]'); if (!modal) return;
    modal.classList.add('open');
    const subj = modal.querySelector('input[name="contact[subject]"]'); if (subj) subj.value = 'Gallery enquiry for item ' + state.id;
  });
  els.share.addEventListener('click', async ()=>{
    const url = location.origin + location.pathname + '#item-' + encodeURIComponent(state.id);
    try { await navigator.clipboard.writeText(url); els.share.textContent='Copied'; setTimeout(()=>els.share.textContent='Share',1200); }
    catch(_){ prompt('Copy URL:', url); }
  });

  function getJSONFor(id) {
    const tag = document.getElementById('cg-json-'+CSS.escape(id));
    if (!tag) return null;
    try { return JSON.parse(tag.textContent.trim()); } catch(e) { console.error('Bad JSON', e); return null; }
  }

  // Click handler
  root.addEventListener('click', function(e){
    const link = e.target.closest('[data-item-id]');
    if (!link || !root.contains(link)) return;
    e.preventDefault();
    const id = link.getAttribute('data-item-id');
    if (!id) return; // safety
    const caption = link.getAttribute('data-caption') || '';
    const productUrl = link.getAttribute('data-product-url') || '#';
    const data = getJSONFor(id);
    if (!data || !data.length) return;
    openOverlay(data, 0, caption, productUrl, id);
  });

  // Deep link
  function openFromHash(){
    const m = (location.hash||'').match(/^#item-(.+)$/);
    if (!m) return;
    const id = decodeURIComponent(m[1]);
    const trigger = root.querySelector('[data-item-id="'+CSS.escape(id)+'"]');
    if (!trigger) return;
    const data = getJSONFor(id);
    if (!data || !data.length) return;
    openOverlay(data, 0, trigger.getAttribute('data-caption')||'', trigger.getAttribute('data-product-url')||'#', id);
  }
  openFromHash();
  addEventListener('hashchange', openFromHash);

  // Load more (kept)
  const btn = root.querySelector('[data-load-more]');
  if (btn) btn.addEventListener('click', async ()=>{
    const next = parseInt(btn.getAttribute('data-next-page'), 10); if(!next) return;
    btn.disabled = true; btn.textContent = 'Loading...';
    try {
      const url = new URL(location.href); url.searchParams.set('section_id', '{{ section.id }}'); url.searchParams.set('page', next);
      const res = await fetch(url.toString(), { headers:{'X-Requested-With':'XMLHttpRequest'}});
      const html = await res.text(); const tmp = document.createElement('div'); tmp.innerHTML = html;
      const incoming = tmp.querySelector('[data-section-id="{{ section.id }}"]');
      const grid = root.querySelector('[data-grid]'); const newGrid = incoming && incoming.querySelector('[data-grid]');
      newGrid && Array.from(newGrid.children).forEach(n=>grid.appendChild(n));
      const nextBtn = incoming && incoming.querySelector('[data-load-more]');
      if (nextBtn) { btn.setAttribute('data-next-page', nextBtn.getAttribute('data-next-page')); btn.disabled=false; btn.textContent='Load more';
        if (nextBtn.hasAttribute('disabled')) { btn.setAttribute('disabled',''); btn.textContent='All caught up'; }
      } else { btn.setAttribute('disabled',''); btn.textContent='All caught up'; }
    } catch(e){ console.error(e); btn.disabled=false; btn.textContent='Load more'; }
  });

  // Contact modal close
  document.addEventListener('click', (e)=>{ const modal = document.querySelector('.cg-modal.open'); if (modal && e.target===modal) modal.classList.remove('open'); });
  root.querySelector('[data-modal-close]')?.addEventListener('click', ()=>{ document.querySelector('.cg-modal.open')?.classList.remove('open'); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
